import { Activity } from '../entity';
import { ActivityId } from '../value';
import { FirestoreQueryBuilder } from 'gcp/builder/firestore-query.builder';
import { IRepository } from '../../../../utility/repository/repository';
import { Observable } from 'rxjs';

export abstract class IActivityRepository extends IRepository<ActivityId, Activity> {
  abstract selectAll(builder: FirestoreQueryBuilder<Activity>): Observable<Activity>;
}
